import React from 'react';

import useCycles from 'components/Common/VoluntaryBenefits/Hooks/useCycles';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import { useContext as useUsersContext } from 'components/Users/Context';

import WithoutCycles from './WithoutCycles';

import WithCycles from './WithCycles';

export default function Index() {
  const { state: stateUsers } = useUsersContext();

  const member = stateUsers.user.attributes.specific;

  const cycles = useCycles({
    teamId: member.team_id,
    memberId: member.id,
  });

  if (cycles === null) {
    return (
      <LoadingPlaceholder text="Loading..." className="py-5" />
    );
  }

  return (
    <div className="mt-4">
      {cycles.length === 0 ? <WithoutCycles /> : <WithCycles cycles={cycles} />}
    </div>
  );
}
